module.exports = __webpack_public_path__ + "img/mintGreen.8b4361a3.png";